export default "__VITE_ASSET__4d1492a6__"